export default {
  ADMIN: "super-admin", // 1
  SALES: "sales", // 2
  MANAGER: "manager", // 3
  TOW_COMPANY: "tow-company", // 4
  TOW_DRIVER: "tow-driver", // 5
  TENANT: "tenant", // 6
  GUEST: "guest", // 7
  PB_SUPPORT_STAFF: "pb-support-staff", // 8 - Account Manager
  PB_FIELD_AGENT: "pb-field-agent", // 9 - Customer Service
  CLIENT_SERVICE_REP: "client-service-rep", // 10
  LEASING_STAFF: "leasing-staff", // 11
  TOW_COMPANY_SALES_REP: "tow-company-sales-rep", // 12
};



// WEBPACK FOOTER //
// ./src/roles/roles.js